import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// tslint:disable-next-line: max-line-length
import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ClickOutsideModule } from 'ng-click-outside';
import { RouterModule } from '@angular/router';

import { SlimscrollDirective } from './slimscroll.directive';

import { PreloaderComponent } from './preloader/preloader.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { FeatherIconDirective } from './feather-icon.directive';
import { EditShowtimesTheatersComponent } from './edit-showtimes-theaters/edit-showtimes-theaters.component';
import { EditShowtimesMoviesComponent } from './edit-showtimes-movies/edit-showtimes-movies.component';

@NgModule({
  declarations: [SlimscrollDirective, PreloaderComponent, PagetitleComponent, FeatherIconDirective, EditShowtimesTheatersComponent, EditShowtimesMoviesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ClickOutsideModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbTooltipModule,
    NgbDropdownModule,
    RouterModule
  ],
  exports: [
    SlimscrollDirective,
    FeatherIconDirective,
    PreloaderComponent,
    PagetitleComponent,
    EditShowtimesTheatersComponent,
    EditShowtimesMoviesComponent
]
})
export class UIModule { }
